import MinimumQuantity from '../../../components/minimum-quantity/MinimumQuantity'
import { isBelowMinimum } from '../../../utils/minimumQuantity'
import React, { useEffect, useState } from 'react'
import QuantityInput from '../../quantity-input/QuantityInput'
import { IProduct } from '../../../types/products'
import './CartItem.scss'
import { imageUrl } from '../../../utils/imageUrl'
import i18next from 'i18next'
import { getStorageKey, getAppType } from '../../../utils/appType'

type Props = {
  data: IProduct
  setCart: React.Dispatch<React.SetStateAction<IProduct[]>>
}
const c = 'cart-item'

const CartItem = ({ data, setCart }: Props) => {
  const cartData = JSON.parse(
    localStorage.getItem(getStorageKey('cart')) || '[]',
  )
  const [quantity, setQuantity] = useState(data?.quantity || 1)

  useEffect(() => {
    setQuantity(data?.quantity ?? 1)
  }, [data?.quantity])

  useEffect(() => {
    const newCart = [...cartData]

    const cartItemIndex = newCart.findIndex(
      (item: IProduct) => item._id === data._id,
    )

    if (cartItemIndex !== -1) {
      newCart[cartItemIndex].quantity = quantity

      if (quantity < 1) {
        newCart.splice(cartItemIndex, 1)
      }
    }

    setCart(newCart)
  }, [quantity])

  return (
    <div className={`${c}${isBelowMinimum(data) ? ' minimum-quantity-invalid' : ''}`}>
      <div className={`${c}__info`}>
        <div className={`${c}__info-image`}>
          <img
            src={imageUrl(data?.image, 128)}
            alt='item'
            loading='lazy'
            decoding='async'
            onError={({ currentTarget }) => {
              currentTarget.onerror = null

              currentTarget.src =
                getAppType() === 'catering'
                  ? '/panda-catering-logo-bamboo.png'
                  : '/logo_bg.png'
            }}
          />
        </div>
        <div className={`${c}__info-text`}>
          <div className={`${c}__info-text-title`}>
            {i18next.language === 'ru' && data?.ru_name
              ? data?.ru_name
              : data?.name}
          </div>
          {data?.selectedIngredients && data.selectedIngredients.length > 0 && (
            <div className={`${c}__info-text-ingredients`}>
              {data.selectedIngredients.map((ing) => (
                <span
                  key={ing._id}
                  className={`${c}__info-text-ingredients-item`}
                >
                  +
                  {i18next.language === 'ru' && ing.label_ru
                    ? ing.label_ru
                    : ing.label}
                </span>
              ))}
            </div>
          )}
          <div className={`${c}__info-text-quantity`}>
            <QuantityInput
              quantity={quantity}
              setQuantity={setQuantity}
              cartItem
            />
          </div>
        </div>
      </div>
      <div className={`${c}__price`}>{data?.price} lei</div>
      {isBelowMinimum(data) && <MinimumQuantity product={data} invalid compact />}
    </div>
  )
}

export default CartItem
